import React from "react";

const Checkbox = ({label, checked, handleCheckboxChange, name, id}) => (
    <div
        className="form-check"
        key={id}
    >
        <input
            className="form-check-input"
            type="checkbox"
            value=""
            id={id}
            name={name}
            checked={checked}
            onChange={handleCheckboxChange}
        />
        <label
            className="form-check-label"
            htmlFor={id}
        >
            {label}
        </label>
    </div>
);


export default Checkbox;